import type { AdminView } from "./types";

export const ADMIN_VIEW_PATH: Record<AdminView, string> = {
  reports: "reports",
  "activity-module": "activity-module",
  "word-master": "word-master",
  contributions: "contributions",
  users: "users",
  "my-profile": "my-profile",
};

export function adminPathFromView(view: AdminView): string {
  return `/admin/${ADMIN_VIEW_PATH[view]}`;
}

export function adminViewFromSegment(
  segment: string | undefined
): AdminView | null {
  if (!segment) {
    return null;
  }
  const match = (Object.keys(ADMIN_VIEW_PATH) as AdminView[]).find(
    v => ADMIN_VIEW_PATH[v] === segment
  );
  return match ?? null;
}
